// extracted by mini-css-extract-plugin
export default {"AIButton":"Button_styles_AIButton__UB6BG"};